<template>
    <div class="outer absolute bottom-0 mt-6 right-0 mr-5 z-10">
        <transition name="fade">
            <div v-if="$page.props.flash.success && show" class="px-5 mb-8 flex items-center justify-between bg-teal-800 rounded shadow-lg">
                <div class="flex items-center">
                    <i class="fad fa-check text-teal-200 mr-2 text-xl"></i>
                    <div class="py-4 text-teal-100 text-base" v-html="$page.props.flash.success"></div>
                </div>
            </div>
        </transition>

        <div v-if="Object.keys($page.props.errors).length > 0 && show" class="mb-8 flex items-center justify-between bg-red-100  px-5 text-red-600 rounded shadow-lg">
            <div class="flex items-center">
                <i class="fas fa-exclamation-triangle mr-3"></i>

                <div class="py-4 text-base">
                    <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.</span>
                    <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</span>
                </div>
            </div>

            <button type="button" class="group ml-5 mr-2 p-2" @click="show = false">
                <i class="fal fa-times text-red-600"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: true
        };
    },
    watch: {
        "$page.flash": {
            handler() {
                this.show = true;

                if (this.$page.props.flash.success) {
                    setTimeout(() => {
                        this.show = false;
                    }, 5000);
                }
            },
            deep: true
        }
    }
};
</script>
<style>
.outer {
    min-width: 320px;
}

.fade-enter-active {
    transition: opacity 0.3s;
}
.fade-leave-active {
    transition: opacity, 0.8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
